/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_TurnInputs */

const en_page_turn = /** @type {(inputs: Page_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page Turn`)
};

const es_page_turn = /** @type {(inputs: Page_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasar página`)
};

const fr_page_turn = /** @type {(inputs: Page_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tourner la page`)
};

const de_page_turn = /** @type {(inputs: Page_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umblättern`)
};

const ja_page_turn = /** @type {(inputs: Page_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ページめくり`)
};

const zh_page_turn = /** @type {(inputs: Page_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻页`)
};

const ar_page_turn = /** @type {(inputs: Page_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقليب الصفحة`)
};

const id_page_turn = /** @type {(inputs: Page_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balik Halaman`)
};

const it_page_turn = /** @type {(inputs: Page_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volta Pagina`)
};

const ru_page_turn = /** @type {(inputs: Page_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перелистывание страниц`)
};

const pt_page_turn = /** @type {(inputs: Page_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virar Página`)
};

const ko_page_turn = /** @type {(inputs: Page_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이지 넘기기`)
};

/**
* | output |
* | --- |
* | "Page Turn" |
*
* @param {Page_TurnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const page_turn = /** @type {((inputs?: Page_TurnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_TurnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_page_turn(inputs)
	if (locale === "es") return es_page_turn(inputs)
	if (locale === "fr") return fr_page_turn(inputs)
	if (locale === "de") return de_page_turn(inputs)
	if (locale === "ja") return ja_page_turn(inputs)
	if (locale === "zh") return zh_page_turn(inputs)
	if (locale === "ar") return ar_page_turn(inputs)
	if (locale === "id") return id_page_turn(inputs)
	if (locale === "it") return it_page_turn(inputs)
	if (locale === "ru") return ru_page_turn(inputs)
	if (locale === "pt") return pt_page_turn(inputs)
	return ko_page_turn(inputs)
});